export class ReportListRequest {
    constructor( 
        public ClinicID?: string,
        public PatientID?: string,
        public FromDate?: string,
        public ToDate?: string,
    ) {}
}